<template>
  <div>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="19"
      viewBox="0 0 21 19"
      fill="none"
    >
      <path
        d="M15.5319 11.0535C15.5319 13.7428 13.3533 15.9214 10.6641 15.9214C7.97478 15.9214 5.79621 13.7428 5.79621 11.0535C5.79621 10.3642 5.93906 9.70351 6.19978 9.11066H0.664062V17.1857C0.664062 17.9285 1.27121 18.5357 2.01406 18.5357H19.3141C20.0569 18.5357 20.6641 17.9285 20.6641 17.1857V9.11066H15.1283C15.3891 9.70351 15.5319 10.3642 15.5319 11.0535Z"
        fill="#9B237B"
      />
      <path
        d="M2.01406 3.66782H3.58906V8.39639H0.664062V5.02139C0.664062 4.27853 1.27121 3.66782 2.01406 3.66782Z"
        fill="#9B237B"
      />
      <path
        d="M4.74196 3.66436H2.65625V3.07864C2.65625 2.73936 2.93125 2.46436 3.27054 2.46436H4.12768C4.46696 2.46436 4.74196 2.73936 4.74196 3.07864V3.66436Z"
        fill="#9B237B"
      />
      <path
        d="M4.30469 3.66797H17.0261V8.39654H14.744C13.8761 7.0644 12.3725 6.18583 10.6654 6.18583C8.95826 6.18583 7.45469 7.0644 6.58683 8.39654H4.30469V3.66797Z"
        fill="#9B237B"
      />
      <path
        d="M18.6717 3.07864V3.66436H16.5859V3.07864C16.5859 2.73936 16.8609 2.46436 17.2002 2.46436H18.0574C18.3967 2.46436 18.6717 2.73936 18.6717 3.07864Z"
        fill="#9B237B"
      />
      <path
        d="M20.6633 5.02154V8.39654H17.7383V3.66797H19.3133C20.0561 3.66797 20.6633 4.27868 20.6633 5.02154Z"
        fill="#9B237B"
      />
      <path
        d="M10.0682 14.089H11.261C11.4503 14.089 11.6039 13.9354 11.6039 13.7462V11.9926H13.3575C13.5468 11.9926 13.7003 11.839 13.7003 11.6497V10.4569C13.7003 10.2676 13.5468 10.114 13.3575 10.114H11.6039V8.36043C11.6039 8.17115 11.4503 8.01758 11.261 8.01758H10.0682C9.87891 8.01758 9.72534 8.17115 9.72534 8.36043V10.114H7.97176C7.78248 10.114 7.62891 10.2676 7.62891 10.4569V11.6497C7.62891 11.839 7.78248 11.9926 7.97176 11.9926H9.72534V13.7462C9.72534 13.9354 9.87891 14.089 10.0682 14.089Z"
        fill="#9B237B"
      />
      <path
        d="M8.10781 2.33571C8.10781 2.00357 8.38281 1.72857 8.71495 1.72857H12.6078C12.94 1.72857 13.215 2.00357 13.215 2.33571V2.95357H14.94V1.52857C14.94 0.689286 14.2542 0 13.415 0H7.90781C7.06853 0 6.38281 0.689286 6.38281 1.52857V2.95357H8.10781V2.33571Z"
        fill="#9B237B"
      />
    </svg>
  </div>
</template>
